import PropTypes from "prop-types"
import React from "react"
import {
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  Form,
  FormFeedback,
  Label,
} from "reactstrap"
import FileUpload from "../Upload/fileUpload"

const CargaModal = ({ show, onCloseClick }) => {
  // declare constants

  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true} backdrop={true}>
      <Form
        onSubmit={e => {
          e.preventDefault()
          return false
        }}
      >
        <div className="modal-content">
          <ModalHeader toggle={onCloseClick} tag="h4">
            Carga Publicações
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col className="col-12">
                <a
                  href={process.env.REACT_APP_STORAGE_PATHMODELOPJE}
                  target="_blank"
                  rel="noreferrer"
                >
                  Baixar planilha modelo
                </a>
                <br />
                <br />
                <FileUpload container="publicacoes" />
              </Col>
            </Row>
            {/* <Row>
                            <Col>
                                <div className="text-end">
                                    <button type="submit" className="btn btn-success save-carga">Carregar</button>
                                </div>
                            </Col>
                        </Row>                             */}
          </ModalBody>
        </div>
      </Form>
    </Modal>
  )
}

CargaModal.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
}

export default CargaModal
